import { Button } from '@components/Button';
import { ProgressBar } from '@components/ProgressBar/ProgressBar';

interface Props {
  clickHandler: () => void;
  disabled: boolean;
  text: string;
  viewedResults: number;
  totalResults?: number;
}

export function LoadMore({
  clickHandler,
  disabled,
  text,
  viewedResults,
  totalResults,
}: Props) {
  const percentage = totalResults
    ? Math.floor((viewedResults / totalResults) * 100) > 100
      ? 100
      : Math.floor((viewedResults / totalResults) * 100)
    : 0;
  return (
    <>
      {typeof totalResults === 'number' && totalResults > 0 ? (
        <div data-testid="load-more-results" className="grid grid-cols-1 gap-1">
          <span className="justify-self-center">
            You've viewed {viewedResults} of {totalResults} results
          </span>
          {percentage > 0 && <ProgressBar percentage={percentage} />}
        </div>
      ) : typeof totalResults === 'number' ? (
        <div className="grid grid-cols-1">
          <span className="justify-self-center">No results</span>
        </div>
      ) : null}
      <Button
        onClick={clickHandler}
        className="mx-auto my-4 flex w-fit cursor-pointer justify-self-center"
        disabled={disabled}
      >
        {text}
      </Button>
    </>
  );
}
